import SEO from "../seo/SEO";
import {
  physicianSchema,
  webPageSchema,
  breadcrumbSchema,
} from "../seo/schemas";

export default function PolicyPage({
  kind = "privacy",
  title,
  intro,
  sections = [],
  lastUpdated = "December 2025",
}) {
  const seoTitle = `${title} | Dr. Indresh Dixit — Gastroenterologist, Varanasi`;
  const url = `/${kind}`;

  return (
    <main data-testid={`${kind}-page`}>
      <SEO
        title={seoTitle}
        description={intro?.slice(0, 160)}
        canonical={url}
        schemas={[
          physicianSchema(),
          webPageSchema({ name: title, description: intro, url }),
          breadcrumbSchema([
            { label: "Home", url: "/" },
            { label: title },
          ]),
        ]}
      />

      <section className="border-b border-black/10">
        <div className="container-x pt-16 md:pt-24 pb-12">
          <div className="overline">{kind === "disclaimer" ? "Medical Disclaimer" : kind === "terms" ? "Terms of Use" : "Privacy Policy"}</div>
          <h1
            data-testid="policy-h1"
            className="font-serif-display mt-5 text-5xl sm:text-6xl lg:text-[72px] leading-[1.02] tracking-tight max-w-4xl"
          >
            {title}
          </h1>
          <p className="mt-6 text-black/70 text-[17px] leading-relaxed max-w-3xl">
            {intro}
          </p>
          <div className="mt-6 text-[12px] tracking-[0.18em] uppercase text-black/55 font-semibold">
            Last updated · {lastUpdated}
          </div>
        </div>
      </section>

      <article className="container-x py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-3 hidden lg:block">
          <div className="sticky top-24">
            <div className="overline">On this page</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              {sections.map((s) => (
                <li key={s.id}>
                  <a
                    href={`#${s.id}`}
                    className="text-black/70 hover:text-[#0370AD] border-l-2 border-black/10 hover:border-[#0370AD] pl-3 block transition-colors"
                  >
                    {s.heading}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </aside>
        <div className="lg:col-span-9 space-y-12">
          {sections.map((s, i) => {
            const HTag = i < 3 ? "h2" : "h3";
            return (
              <section
                key={s.id}
                id={s.id}
                data-testid={`policy-section-${s.id}`}
                className="scroll-mt-24"
              >
                <HTag className="font-serif-display text-3xl md:text-4xl tracking-tight leading-tight">
                  {String(i + 1).padStart(2, "0")}. {s.heading}
                </HTag>
                <div className="mt-5 text-black/75 text-[16px] leading-relaxed space-y-4 max-w-3xl">
                  {typeof s.body === "string"
                    ? s.body
                        .split("\n\n")
                        .map((p, idx) => <p key={idx}>{p}</p>)
                    : s.body}
                </div>
                {s.bullets && (
                  <ul className="mt-5 space-y-2.5 max-w-3xl">
                    {s.bullets.map((b, idx) => (
                      <li
                        key={idx}
                        className="flex items-start gap-3 text-[15px] text-black/80"
                      >
                        <span className="text-[#0370AD] mt-1.5 h-1 w-1 rounded-full bg-[#0370AD] shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            );
          })}
        </div>
      </article>
    </main>
  );
}
